"use strict";

exports.__esModule = true;
exports.default = exports.StateUI = exports.ToggleUI = exports.BackdropUI = exports.InputUI = exports.SwitchUI = exports.WrapperUI = exports.config = void 0;

var _baseStylesCss = _interopRequireDefault(require("../../../styles/resets/baseStyles.css.js"));

var _color = require("../../../styles/utilities/color");

var _forEach = _interopRequireDefault(require("../../../styles/utilities/forEach"));

var _styled = _interopRequireDefault(require("../../styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var config = {
  backgroundColor: {
    default: (0, _color.getColor)('grey.500'),
    disabled: (0, _color.getColor)('grey.300'),
    hover: (0, _color.getColor)('grey.600')
  },
  backgroundColorChecked: {
    default: (0, _color.getColor)('green.500'),
    disabled: (0, _color.getColor)('green.300'),
    hover: (0, _color.getColor)('green.600')
  },
  borderRadius: 100,
  color: {
    default: (0, _color.getColor)('charcoal.200'),
    disabled: (0, _color.getColor)('charcoal.400'),
    checked: 'white'
  },
  fontSize: 12,
  padding: '0 10px',
  toggle: {
    offset: 2
  },
  size: {
    lg: 28,
    md: 21,
    sm: 16
  },
  transition: {
    switch: 'all 300ms ease',
    toggle: 'all 200ms ease'
  }
};
exports.config = config;
var WrapperUI =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "e15htbio0"
})(_baseStylesCss.default, " display:inline-block;");
exports.WrapperUI = WrapperUI;
var SwitchUI =
/*#__PURE__*/
(0, _styled.default)('label', {
  target: "e15htbio1"
})(_baseStylesCss.default, " cursor:pointer;display:block;margin:0;position:relative;&.is-disabled{pointer-events:none;}&.is-loading{pointer-events:none;}");
exports.SwitchUI = SwitchUI;
var InputUI =
/*#__PURE__*/
(0, _styled.default)('input', {
  target: "e15htbio2"
})(_baseStylesCss.default, " bottom:0;height:100%;left:0;margin:0;opacity:0;position:absolute;right:0;top:0;width:100%;z-index:-1;");
exports.InputUI = InputUI;
var BackdropUI =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "e15htbio3"
})("background-color:", config.backgroundColor.default, ";border-radius:", config.borderRadius, "px;box-shadow:0 0 0 0 rgba(0,0,0,0.1) inset;box-sizing:border-box;color:", config.color.default, ";cursor:pointer;font-size:", config.fontSize, "px;padding:", config.padding, ";pointer-events:none;position:relative;text-align:right;transition:", config.transition.switch, ";z-index:1;&.is-focused{background-color:", config.backgroundColor.hover, ";}&.is-disabled{background-color:", config.backgroundColor.disabled, ";color:", config.color.disabled, ";}&.is-checked{background-color:", config.backgroundColorChecked.default, ";color:", config.color.checked, ";text-align:left;&.is-focused{background-color:", config.backgroundColorChecked.hover, ";}&.is-disabled{background-color:", config.backgroundColorChecked.disabled, ";color:", config.color.disabled, ";}}", makeSizeStyles(config), ";");
exports.BackdropUI = BackdropUI;
var ToggleUI =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "e15htbio4"
})("background-color:white;border-radius:", config.borderRadius, "px;box-shadow:0 2px 4px rgba(0,0,0,0.1);box-sizing:border-box;content:'';left:", config.toggle.offset, "px;pointer-events:none;position:absolute;top:", config.toggle.offset, "px;transition:", config.transition.toggle, ";", makeToggleSizeStyles(config), " &.is-active{width:60%;}&.is-checked{left:inherit;right:", config.toggle.offset, "px;}&.is-loading{animation:SwitchTogglePulse 1000ms linear infinite;left:50%;right:inherit;", makeToggleOffsetStyles(config), "}@keyframes SwitchTogglePulse{0%{box-shadow:0 0 0 rgba(0,0,0,0);transform:scale(0.8);}50%{box-shadow:0 0 0 rgba(0,0,0,0);transform:scale(0.6);}100%{box-shadow:0 0 0 rgba(0,0,0,0);transform:scale(0.8);}}}");
exports.ToggleUI = ToggleUI;
var StateUI =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "e15htbio5"
})("border-radius:100px;bottom:0;box-shadow:0 0 0 2px ", (0, _color.getColor)('state.error'), ";display:block;left:0;opacity:0.7;position:absolute;right:0;top:0;z-index:0;");
exports.StateUI = StateUI;

function getWidth(size) {
  return Math.floor(size * 2);
}

function makeSizeStyles(config) {
  return (0, _forEach.default)(config.size, function (size, value) {
    return "\n    &.is-" + size + " {\n      height: " + value + "px;\n      line-height: " + value + "px;\n      width: " + getWidth(value) + "px;\n    }\n  ";
  });
}

function makeToggleSizeStyles(config) {
  return (0, _forEach.default)(config.size, function (size, value) {
    return "\n    &.is-" + size + " {\n      height: " + (value - config.toggle.offset * 2) + "px;\n      width: " + (value - config.toggle.offset * 2) + "px;\n    }\n  ";
  });
}

function makeToggleOffsetStyles(config) {
  return (0, _forEach.default)(config.size, function (size, value) {
    return "\n    &.is-" + size + " {\n      margin-left: -" + (value / 2 - config.toggle.offset / 1) + "px;\n    }\n  ";
  });
}

var _default = SwitchUI;
exports.default = _default;